import { ModelBase } from 'store/model-base';

export class CmsInternational extends ModelBase {
    public static storeName: string = 'cmsInternational';

    public internationalDetails: CmsInternationalDetails;
}
